export interface UserCardVariantConfig {
  showKudos?: boolean;
  showNavigateToProfile?: boolean;
  showDuration?: boolean;
  expanded?: boolean;
}

export type UserCardVariant = "bulletin" | "community" | "profile";

export const VARIANTS: Record<string, UserCardVariantConfig> = {
  BULLETIN: {
    showKudos: true,
    showNavigateToProfile: true,
    showDuration: true,
    expanded: false,
  },
  COMMUNITY: {
    showKudos: true,
    showNavigateToProfile: true,
    showDuration: true,
    expanded: false,
  },
  PROFILE: {
    showKudos: true,
    showNavigateToProfile: false,
    showDuration: false,
    expanded: true,
  },
};

export const getConfig = (variant?: string): UserCardVariantConfig => {
  return VARIANTS[variant?.toUpperCase() || ""] || VARIANTS.COMMUNITY;
};
